import { defineRouting } from 'next-intl/routing';

export const DEPRECATED_LOCALE_COOKIE = 'hp-locale';

export const routing = defineRouting({
  locales: ['en', 'es'] as const,
  defaultLocale: 'en',
  // English stays at `/`; Spanish keeps the reserved `/es` prefix for launch.
  localePrefix: 'as-needed',
  localeCookie: false,
  // Keep unprefixed URLs in the default locale regardless of Accept-Language
  // or stale locale cookies. Locale changes require an explicit URL prefix.
  localeDetection: false,
});

export type SupportedLocale = (typeof routing.locales)[number];

export const STUBBED_LOCALES = ['es'] as const satisfies ReadonlyArray<SupportedLocale>;

const stubbedLocaleSet = new Set<SupportedLocale>(STUBBED_LOCALES);

export function isStubbedLocale(locale: string): locale is (typeof STUBBED_LOCALES)[number] {
  return stubbedLocaleSet.has(locale as SupportedLocale);
}
